// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"587":"99023d5c","787":"1c1dc9a5"}[chunkId] + ".chunk.js";
};